// src/components/Navbar/Navbar.jsx
import { Menu, X } from "lucide-react";
import UserMenu from "../UserMenu/UserMenu";
import "./Navbar.css";

const Navbar = ({ isSidebarOpen, toggleSidebar, user }) => {
    return (
        <nav className="bg-white shadow p-4 flex items-center justify-between">
            {/* Botón toggle sidebar */}
            <button type="button" onClick={toggleSidebar} aria-label="Alternar menú lateral">
                {isSidebarOpen ? <X size={24} /> : <Menu size={24} />}
            </button>

            {/* Logo */}
            <h1 className="navbar-brand-gradient text-2xl font-bold">NEBULOX</h1>

            <UserMenu user={user} />
        </nav>
    );
};

export default Navbar;
